import axios from 'axios'
import { withPrefix } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Timeline, TimelineEvent } from 'react-event-timeline'
import { v4 as uuidv4 } from 'uuid'
import { StyledReferences } from '../styles'
import { StyledTimeline } from '../styles'
import Article from '../templates/Article'

const Page = props => {
  const [data, setData] = useState([])
  const [references, setReferences] = useState([])

  useEffect(() => {
    async function fetchData() {
      const response = await axios(withPrefix('/data/eme5054/timeline.json'))
      setData(response.data.timeline)
      setReferences(response.data.references)
    }
    fetchData()
  }, [])

  function createMarkup(markup) {
    return { __html: markup }
  }

  const RenderTimeline = () => {
    if (data) {
      return (
        <>
          <Timeline>
            {data.map(
              ({ image, createdAt, details, iconColor, title, video }) => (
                <TimelineEvent
                  key={uuidv4()}
                  title={title}
                  createdAt={createdAt}
                  icon={
                    <img
                      className="event-icon"
                      src={withPrefix('/ui/Smock_Calendar_18_N.svg')}
                      alt="calender icon"
                    />
                  }
                  iconColor={iconColor ? iconColor : '#a0b2b8'}
                >
                  <div
                    className="event-details"
                    dangerouslySetInnerHTML={createMarkup(details)}
                  />
                  {image && (
                    <div
                      css={css`
                        margin-top: 0.75rem;

                        img {
                          max-width: 100%;
                        }
                      `}
                    >
                      <img
                        src={withPrefix(`/media/${image.src}`)}
                        alt={image.alt}
                      />
                    </div>
                  )}
                  {video && (
                    <div
                      css={css`
                        margin: 1.5rem auto;
                        align-items: center;
                        display: flex;
                        justify-content: center;
                      `}
                    >
                      <video controls preload="auto">
                        <source
                          src={withPrefix(`/dswmedia/${video.src}`)}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  )}
                </TimelineEvent>
              )
            )}
          </Timeline>
        </>
      )
    }

    return <p>loading...</p>
  }

  return (
    <Article
      pathName={props.location.pathname}
      pageTitle="The History of Educational Design"
    >
      <h1>The History of Educational Technology - A Timeline</h1>
      <StyledTimeline aria-label="timeline of events" role="main">
        <RenderTimeline />
      </StyledTimeline>
      <StyledReferences>
        <section aria-labelledby="section-references">
          <h2 id="section-references">References</h2>
          <ul>
            {references.map(({ author, date, href, title }) => (
              <li key={uuidv4()}>
                {author}. "{title}", {date}{' '}
                {href ? (
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    {href}
                  </a>
                ) : null}
              </li>
            ))}
          </ul>
        </section>
        <section aria-labelledby="section-photos">
          <h2 id="section-photos">Media Sources</h2>
          <ul>
            {data.map(({ title, mediaURL }) => {
              if (mediaURL) {
                return (
                  <li key={uuidv4()}>
                    {title}{' '}
                    <a
                      href={mediaURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {mediaURL}
                    </a>
                  </li>
                )
              }
              return null
            })}
          </ul>
        </section>
      </StyledReferences>
    </Article>
  )
}

Page.propTypes = {
  location: PropTypes.object,
}

export default Page
